import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./headerMenu.html";
const MENU_CLASS_NAME = 'dropdown-menu';
const BACK_DROP_CLASS_NAME = 'backdrop';
const TRIGGER_CLASS_NAME = 'menu-trigger';
class HeaderMenu extends LightningElement {
  constructor(...args) {
    super(...args);
    this.menuName = 'menu';
    this.imageUrl = void 0;
    this.imageAlt = void 0;
    this._activeItem = 0;
    this._shouldFocusActiveItem = false;
    this._menuItems = void 0;
    this.menuExpanded = false;
  }
  get menuItems() {
    return this._menuItems;
  }
  set menuItems(items) {
    this._menuItems = items;
  }
  get menuTriggerClassName() {
    return TRIGGER_CLASS_NAME + (this.menuExpanded ? ' expanded' : '');
  }
  get menuClassName() {
    return MENU_CLASS_NAME + (this.menuExpanded ? ' expanded' : '');
  }
  get backDropClassName() {
    return BACK_DROP_CLASS_NAME + (this.menuExpanded ? '' : ' hidden');
  }
  renderedCallback() {
    if (this.menuExpanded) {
      this.focusDropdown();
    }
    if (this._shouldFocusActiveItem) {
      this.focusActiveItem();
    }
  }
  toggleMenu() {
    this.menuExpanded = !this.menuExpanded;
    if (this.menuExpanded) {
      this.setActiveMenuItem();
    } else {
      this._activeItem = 0;
      this._shouldFocusActiveItem = false;
    }
  }
  focusDropdown() {
    this.template.querySelector('div[data-menu="menu"]').focus();
  }
  focusTrigger() {
    this.template.querySelector('img[data-menu="trigger"]').focus();
  }
  setActiveMenuItem() {
    this._menuItems = this._menuItems.map(item => {
      return {
        ...item,
        active: item.position === this._activeItem
      };
    });
  }
  selectNextMenuItem() {
    this._activeItem++;
    if (this._activeItem > this.menuItems.length) this._activeItem = 1;
    this.setActiveMenuItem();
  }
  selectPreviousMenuItem() {
    this._activeItem--;
    if (this._activeItem < 1) this._activeItem = this.menuItems.length;
    this.setActiveMenuItem();
  }
  handleTriggerKeyDown(event) {
    if (event.key === 'ArrowDown' || event.key === 'Enter') {
      this._activeItem = 1;
      this._shouldFocusActiveItem = true;
      this.toggleMenu();
      event.preventDefault();
    }
  }
  activateMenuItem() {
    if (this._activeItem > 0) {
      this.template.querySelector('a[data-active="true"]').click();
    }
    this.toggleMenu();
  }
  handleMenuKeyDown(event) {
    switch (event.key) {
      case 'Tab':
        this.toggleMenu();
        break;
      case 'Escape':
        this.toggleMenu();
        this.focusTrigger();
        break;
      case 'ArrowDown':
        this.selectNextMenuItem();
        event.preventDefault();
        break;
      case 'ArrowUp':
        this.selectPreviousMenuItem();
        event.preventDefault();
        break;
      case 'Enter':
        this.activateMenuItem();
        break;
      default:
        event.preventDefault();
    }
  }
  focusActiveItem() {
    var _querySelector;
    (_querySelector = this.template.querySelector('a[data-active="true"]')) === null || _querySelector === void 0 ? void 0 : _querySelector.focus();
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(HeaderMenu, {
  publicProps: {
    menuName: {
      config: 0
    },
    imageUrl: {
      config: 0
    },
    imageAlt: {
      config: 0
    },
    menuItems: {
      config: 3
    }
  },
  fields: ["_activeItem", "_shouldFocusActiveItem", "_menuItems", "menuExpanded"]
});
const __lwc_component_class_internal = _registerComponent(HeaderMenu, {
  tmpl: _tmpl,
  sel: "appx-header-menu",
  apiVersion: 62
});
export default __lwc_component_class_internal;